module.exports = {
      id: "forward-usage",
      viewBox: "0 0 24 24",
      url: "/" + "sprite-4add775381efce29ef76f223dff77c00.svg#forward",
      toString: function () {
        return this.url;
      }
    }